var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1445_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2334 1H2.76658C2.34321 1 2 1.32235 2 1.71999V17.0292C2 17.4268 2.34321 17.7492 2.76658 17.7492H15.2334C15.6568 17.7492 16 17.4268 16 17.0292V1.71999C16 1.32235 15.6568 1 15.2334 1Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32959 4.67969H12.67",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32959 7.55957H12.67",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32959 10.4395H12.67",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32959 13.3203H12.67",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage3);
export default __webpack_public_path__ + "static/media/page3.02706043789dc6e9f3386ece0b47047e.svg";
export { ForwardRef as ReactComponent };